<template>
  <section id="homegallery" class="n2-seccion n3-galeria" v-if="G?.Mostrar && fotos.length">
    <div class="n2-contenedor n2-cabeza-seccion n2-cabeza-seccion--fila n2-aparece">
      <div>
        <h2 class="n2-titulo-seccion" v-html="G.Titulo?.Texto || tituloSeccion(NOTARIA, 'Gallery', $t)"></h2>
        <div v-if="G.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(G.Descripcion.css)" v-html="G.Descripcion.Texto"></div>
      </div>
      <div v-if="fotos.length > 1" class="n3-flechas">
        <button type="button" class="n3-flecha" aria-label="Anterior" @click="mover(-1)"><v-icon>mdi-arrow-left</v-icon></button>
        <button type="button" class="n3-flecha" aria-label="Siguiente" @click="mover(1)"><v-icon>mdi-arrow-right</v-icon></button>
      </div>
    </div>
    <!-- Carrusel que pasa solo (ref: https://trello.com/c/rRSWib5q): se para con el ratón encima, el foco de teclado, un toque o la foto abierta -->
    <div ref="pista" class="n3-tira" @mouseenter="pausas.raton = true" @mouseleave="pausas.raton = false"
      @focusin="pausas.foco = $event.target.matches(':focus-visible')" @focusout="pausas.foco = false" @touchstart.passive="tocar">
      <button v-for="(f, i) in fotos" :key="f.id" type="button" class="n3-tira__foto" @click="indice = i; abierta = true" :aria-label="f.Description || f.name">
        <img :src="imagenIDtoSRC(f.id)" :alt="f.Description || ''" loading="lazy" />
        <span v-if="G.MostrarDescripcion && f.Description">{{ f.Description }}</span>
      </button>
    </div>
    <GalleryLightbox v-model="abierta" :images="fotos.map(f => ({ src: imagenIDtoSRC(f.id) }))" :initialIndex="indice" />
  </section>
</template>

<script setup>
import { ref, reactive, computed, onMounted, onBeforeUnmount } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { tituloSeccion, alineacionTexto } from '../../composables/useNotaria2'

const store = useStore()
const { NOTARIA, ARCHIVOS_COMUNES } = storeToRefs(store)
const { imagenIDtoSRC, $t } = useUtils()
const abierta = ref(false)
const indice = ref(0)
// Panel: Inicio → Galería y las imágenes marcadas "Mostrar en la sección de inicio"
const G = computed(() => NOTARIA.value?.Theme?.Home?.Gallery)
const fotos = computed(() => {
  const origen = ARCHIVOS_COMUNES.value?.length ? ARCHIVOS_COMUNES.value : (NOTARIA.value?.Archivos ?? [])
  const lista = origen.filter(a => a.id && a.showInGallerySection)
    .sort((a, b) => (Number(a.Orden) || 9999) - (Number(b.Orden) || 9999))
  const total = Number(G.value?.TotalImagenes) || 0
  return total > 0 ? lista.slice(0, total) : lista
})

const pista = ref(null)
const pausas = reactive({ raton: false, foco: false, toque: false })
let temporizador = null
let finToque = null

// Avanza una foto; al final vuelve al principio (y al revés con la flecha de anterior)
function mover(sentido) {
  const el = pista.value
  if (!el) return
  const max = el.scrollWidth - el.clientWidth
  if (sentido > 0 && el.scrollLeft >= max - 4) return el.scrollTo({ left: 0, behavior: 'smooth' })
  if (sentido < 0 && el.scrollLeft <= 4) return el.scrollTo({ left: max, behavior: 'smooth' })
  const foto = el.querySelector('.n3-tira__foto')
  el.scrollBy({ left: sentido * ((foto?.offsetWidth ?? 300) + 14), behavior: 'smooth' })
}

// Tras tocar, sigue parada unos segundos para que se pueda mirar la foto
function tocar() {
  pausas.toque = true
  clearTimeout(finToque)
  finToque = setTimeout(() => { pausas.toque = false }, 6000)
}

onMounted(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  temporizador = setInterval(() => {
    const el = pista.value
    if (!el || abierta.value || pausas.raton || pausas.foco || pausas.toque || document.hidden) return
    if (el.scrollWidth <= el.clientWidth + 4) return // caben todas: no hay nada que pasar
    mover(1)
  }, 4000)
})
onBeforeUnmount(() => { clearInterval(temporizador); clearTimeout(finToque) })
</script>
